// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1ZLdp","header":"MergedInvoice_header__3EsXa"};